<template>
    <el-dialog
      :modal="true"
      :modal-append-to-body="true"
      :title="title"
      :visible.sync="isShow"
      :close-on-click-modal="true"
      :show-close="true"
      :close-on-press-escape="true"
      center
      :width="wdith">
      <slot></slot>
    </el-dialog>
</template>

<script>
export default {
  data(){
    return{
      isShow:false,
      title:'',
      wdith:'496px'
    }
  },
  methods:{
     isShowDia(title,isVisible,width){
        this.isShow = isVisible
        this.title = title
        this.wdith = width
      },
  }
}
</script>
